import React from 'react'

export const ModelsContext = React.createContext();
